<template>
  <div class="flex justify-center items-center h-screen">
    <div class="justify-center items-center">
      <div v-if="error.message.includes('Page not found')"
        class="flex flex-col justify-center items-center text-xl text-slate-700">
        <NuxtLink to="/">
          <NuxtImg :src="useImageURL('/static/404_image2.jpg', '218x145')" alt="Logo" class="object-contain" />
        </NuxtLink>
        <p class="text-4xl font-bold">Page Not Found</p>
        <!-- <p class="pt-2 text">The page you are looking for doesn’t exist.</p> -->
        <UButton size="xl" @click="goHome" class="m-8" variant="ghost">Go to Home</UButton>
      </div>
      <div v-else class="flex flex-col justify-center items-center text-xl text-slate-700">
        <p>We are really sorry and we will be fixing it as soon as possible.</p>
        <p class="pt-2 text-red-500">Error: {{ error.message }}</p>
        <p class="pt-2 text-red-500">Error: {{ error }}</p>
        <UButton size="xl" @click="goHome" class="m-8" variant="ghost">Go to Home</UButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useError } from "nuxt/app";
import { useRouter } from "vue-router";

const error = useError();
const router = useRouter();
definePageMeta({
  layout: "error",
})
const goHome = () => {
  router.push("/");
};
</script>

<style scoped></style>
